const component = (namespace, elementToQuery = document) => elementToQuery.querySelector(`[data-component="${namespace}"]`);
const components = (namespace, elementToQuery = document) => elementToQuery.querySelectorAll(`[data-component="${namespace}"]`);

class memoiSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this
    this.sliderItems = components('slider-item', this); 
    this.id = this?.dataset?.id ?? '';
    this.nextButton = null;
    this.prevButton = null;
    this.slideWidth = 0;
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.initExternalElements();
    this.initSlider();
    this.initListeners();
  }

  initExternalElements() {
    // Assign controls based on data attributes
    const nextButton = component(`slider-control-next_${this.id}`, document.body);
    if (nextButton) this.nextButton = nextButton;

    const prevButton = component(`slider-control-prev_${this.id}`, document.body);
    if (prevButton) this.prevButton = prevButton;
  }

  initSlider() {
    if (!this.slider || this.sliderItems.length === 0) return;

    this.slideWidth = this.sliderItems[0].offsetWidth;
    this.slider.scrollLeft = 0; 
  }

  initListeners() {
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scrollToSlide('next'));
    }
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scrollToSlide('prev'));
    }
    this.slider.addEventListener('scroll', this.updateControls.bind(this));
  }

  scrollToSlide(direction) {
    const maxScroll = this.slider.scrollWidth - this.slider.offsetWidth;

    if (direction === 'next') {
      this.slider.scrollLeft = Math.min(this.slider.scrollLeft + this.slideWidth, maxScroll);
    } else if (direction === 'prev') {
      this.slider.scrollLeft = Math.max(this.slider.scrollLeft - this.slideWidth, 0);
    }
  }

  updateControls() {
    const atStart = this.slider.scrollLeft === 0;
    const atEnd = this.slider.scrollLeft + this.slider.offsetWidth >= this.slider.scrollWidth;

    if (this.prevButton) {
      this.prevButton.disabled = atStart;
    }
    if (this.nextButton) {
      this.nextButton.disabled = atEnd;
    }
  }
}
customElements.define('memoi-slider', memoiSlider);
